/* eslint-disable react/jsx-sort-props */

/**
 * DO NOT MODIFY THIS ICON DIRECTLY.
 *
 * THIS ICON WAS AUTOMATICALLY GENERATED.
 * SVG RETRIEVED FROM SPRING FOUNDATIONS FIGMA FILE.
 * @see https://www.figma.com/design/kcg95u086DD7Sa9or8Bwpq/%F0%9F%8C%B1--Foundations---Spring-2.0?node-id=24-2&p=f&t=75lUXy0FPOr0htKP-0
 */
import React from 'react';

import {Icon as BaseIcon, type BaseIconProps} from './Icon/Icon';
import {IconComponent} from './types';

export const LoginLogoutUserIcon = React.forwardRef<
  HTMLDivElement,
  BaseIconProps
>(({size = 64, ...props}, ref) => {
  return (
    <BaseIcon {...props} size={size} ref={ref}>
      <svg
        data-wf-icon="LoginLogoutUserIcon"
        width="64"
        height="64"
        viewBox="0 0 64 64"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g>
          <g>
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M32 29C32 27.3431 33.3431 26 35 26C36.6569 26 38 27.3431 38 29C38 30.6569 36.6569 32 35 32C33.3431 32 32 30.6569 32 29ZM35 27C33.8954 27 33 27.8954 33 29C33 30.1046 33.8954 31 35 31C36.1046 31 37 30.1046 37 29C37 27.8954 36.1046 27 35 27Z"
              fill="currentColor"
            />
            <path
              d="M31.5 34C30.6716 34 30 34.6716 30 35.5V37H29V35.5C29 34.1193 30.1193 33 31.5 33H38.5C39.8807 33 41 34.1193 41 35.5V37H40V35.5C40 34.6716 39.3284 34 38.5 34H31.5Z"
              fill="currentColor"
            />
            <path
              d="M20.8536 27.6465L20.1464 28.3537L23.2929 31.5001H14V32.5001H23.2929L20.1464 35.6465L20.8536 36.3537L25.2071 32.0001L20.8536 27.6465Z"
              fill="currentColor"
            />
          </g>
          <path
            opacity="0.4"
            d="M17 17H47V47H17V36.5H16V47C16 47.5523 16.4477 48 17 48H47C47.5523 48 48 47.5523 48 47V17C48 16.4477 47.5523 16 47 16H17C16.4477 16 16 16.4477 16 17V27.5H17V17Z"
            fill="currentColor"
          />
        </g>
      </svg>
    </BaseIcon>
  );
}) as IconComponent;

LoginLogoutUserIcon.tags = ['login', 'user', 'enter', 'account', 'access'];

LoginLogoutUserIcon.category = '64x64 (Add panel)';

LoginLogoutUserIcon.iconSize = 64;
